import { PrimaryButton } from '@library/components/buttons/PrimaryButton';
import type { ReactNode } from 'react';
import { SecondaryButton } from '@library/components/buttons/SecondaryButton';
import { classNames } from '@library/utils';

export interface SubmitResetBarProps {
  cancelText?: string;
  className?: string;
  confirmText?: string;
  handlePublish: () => void;
  handleReset: () => void;
  prefix?: ReactNode;
  saveDisabled?: boolean;
}

export const SubmitResetBar = ({
  cancelText = 'Cancel',
  className = '',
  confirmText = 'Save',
  handlePublish,
  handleReset,
  prefix = undefined,
  saveDisabled = false
}: SubmitResetBarProps) => {
  return (
    <div
      className={classNames(
        'bg-soFresh-130 flex items-center justify-between py-2',
        className
      )}
    >
      <div className="ml-1 flex items-center gap-4">{prefix}</div>

      <div className="flex gap-4 pr-5">
        <SecondaryButton title="Reset Changes" handleOnClick={handleReset}>
          {cancelText}
        </SecondaryButton>
        <PrimaryButton
          disabled={saveDisabled}
          handleOnClick={handlePublish}
          title="Save"
        >
          {confirmText}
        </PrimaryButton>
      </div>
    </div>
  );
};
